import { API_BASE as API, authHeaders } from "./api";
import { normalizeIds } from "../utils/discoveryRotation";

// The homepage Discovery panel's recommendations (GET /spotlight).
//
// `exclude` means "these were displayed recently — pick something else",
// never "the shopper rejected these": rotation is scheduled, not earned by
// a click. The backend fills all three positions itself (personalised,
// then New Arrivals, Best Sellers, Popular), so there are no client-side
// top-ups. Ids are normalized identically for the request and the cache
// key, so a filtered response can never be served from an unfiltered
// entry — or vice versa. The batch key is part of the key too, so a
// period's three products can't be swapped by a refetch.

export const spotlightQueryKey = (visitorId, accountId, excludedIds, batchKey) => [
  "spotlight",
  visitorId ?? null,
  accountId ?? null,
  batchKey ?? null,
  normalizeIds(excludedIds).join(","),
];

export async function fetchSpotlight({ visitorId, token, excludedIds }) {
  const params = new URLSearchParams({ visitor_id: visitorId });
  const ids = normalizeIds(excludedIds);
  if (ids.length) params.set("exclude", ids.join(","));
  const res = await fetch(`${API}/spotlight?${params.toString()}`, { headers: authHeaders(token) });
  if (!res.ok) {
    const err = new Error(`spotlight ${res.status}`);
    err.status = res.status;
    throw err;
  }
  return res.json();
}
